import React from 'react';
import { Award } from 'lucide-react';
import { Card } from './ui/card';

export const CredentialsSection = () => {
  const credentials = [
    "MSc Clinical Psychology (Kristu Jayanti College, Bengaluru North University)",
    "Transactional Analysis 101 (International Transactional Analysis Association)",
    "Trauma Informed Psychosocial Care (Hansraj College, University of Delhi)",
    "Solution Focused Therapy (Institute for Solution Focused Therapy, Netherlands)"
  ];

  return (
    <section className="py-20 px-6 bg-gradient-to-br from-peach-50 via-pink-50 to-lavender-50">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold text-center text-gray-800 mb-12">
          My credentials
        </h2>
        <div className="grid md:grid-cols-2 gap-6">
          {credentials.map((credential, index) => (
            <Card 
              key={index}
              className="p-6 bg-white/70 backdrop-blur-sm border-none shadow-lg hover:shadow-xl transition-all duration-300"
            >
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 mt-1">
                  <Award className="w-6 h-6 text-blue-500" />
                </div>
                <p className="text-lg text-gray-700 leading-relaxed">
                  {credential}
                </p>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};